import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

  
  const __default__ = {
    name: 'RichTextEditorModal',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["saveClicked"],
  setup(__props, { emit }: { emit: ({ (event: 'saveClicked'): void }), expose: any, slots: any, attrs: any }) {

  

  const show = ref(false);

  function showModal(value: boolean) {
    show.value = value;
  }

  function handleSaveButtonClicked() {
    emit('saveClicked');
    show.value = false;
  }

return { __sfc: true,emit, show, showModal, handleSaveButtonClicked }
}

})